export default __webpack_public_path__ + "static/media/Desfazer.353c6687.svg";